import React, { useState } from 'react'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../utils/PiePage.component'

import { useParams } from "react-router-dom";
import { SaveUploadFileDocDetails, getDocumentDetailApi } from './DealerActioncreator'



const maxSize = 100 * 1024 * 1024;

const DocName1 = "Doc1"
const DocName2 = "Doc2"
const Doc1Id="dpATI44NQj3xOTCXWdNL2YG2B67WR6Wz"
const Doc2Id="4BsFN8XMutwtUqh2XE5hSHY5ZHwLEQ2O";

export default function AddDocumentsNew({ handlePage, communityId, handleTabs }) {
    const [loaderState, setLoaderState] = useState(false)
    const [documentName, setDocumentName] = useState({ name1: '', name2: '' })
   

    

    const changeHandler = (e, type,nameType) => {
        console.log(e.target.files[0])
        const fileSize = e.target.files[0]?.size || 0;


        if (fileSize > maxSize) {
            alert('File size exceeded (Max: 100MB)');
        } else {
            // setDocumentName(e.target.files[0]?.name)
            setDocumentName((prev) => ({
                ...prev,
                [nameType]: e.target.files[0]?.name
            }))
            handleUploadDocs(e.target.files[0],type)
           
        }

    }

   

    const saveHandler = (type) => {
       
            handlePage("", "list")
       
    }
    const handleUploadDocs =(file,name)=>{
        const docId = name === "Doc1" ? Doc1Id : Doc2Id

            let multipartFormData = new FormData();
            multipartFormData.append("docName", name);
            multipartFormData.append("description", "");
            multipartFormData.append("file", file);
            multipartFormData.append("documentId", docId);
            multipartFormData.append("type", "pdf");
            multipartFormData.append("fileName",file?.name);
            multipartFormData.append("lenderId", "");
            multipartFormData.append("licenseId", "");
            multipartFormData.append("userId", "");
            multipartFormData.append("loanId", "");
            multipartFormData.append("communityId", communityId);
            multipartFormData.append("replaceOrUpload", 0);
            setLoaderState(true)
            SaveUploadFileDocDetails(multipartFormData, (callback) => {
                console.log(callback)
            setLoaderState(false)

               
            })
        
    }

   

    return (
        <>
            <div className='container hoverNone card'>
                {loaderState ?
                    <Loader />
                    : null}

                <PiePage
                    totalPage={5}
                    currentPage={5}
                    heading={'Add Documents'}
                />

                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <label htmlFor="" style={{ margin: '15px 0' }}>{DocName1}</label>
                        <div className="customUploadInputNew" style={{ margin: '0 0 15px 0' }}>
                            <input type="file" className='customUploadInputTag' name={DocName1} onChange={e => changeHandler(e, DocName1,"name1")} accept='.pdf' />
                            <div className="text">
                                <i class="fa fa-cloud-upload" aria-hidden="true" style={{ fontSize: '30px', color: '#1B6BFE' }}></i>
                                {
                                    documentName && documentName?.name1 !== "" && documentName?.name1 !== null && documentName?.name1 !== undefined ?
                                        <h5>{documentName?.name1}</h5>
                                        :
                                        <>
                                            <h5>Click to Upload <span>or drag and drop</span></h5>
                                            <h6> (Max. File size: 100 MB)</h6>
                                        </>
                                }
                            </div>
                        </div>

                    </div>
                    <div className="col-sm-6 col-xs-12">
                        <label htmlFor="" style={{ margin: '15px 0' }}>{DocName2}</label>
                        <div className="customUploadInputNew" style={{ margin: '0 0 15px 0' }}>
                            <input type="file" className='customUploadInputTag' name={DocName2} onChange={e => changeHandler(e, DocName2,"name2")} accept='.pdf' />
                            <div className="text">
                                <i class="fa fa-cloud-upload" aria-hidden="true" style={{ fontSize: '30px', color: '#1B6BFE' }}></i>
                                {
                                    documentName && documentName?.name2 !== "" && documentName?.name2 !== null && documentName?.name2 !== undefined ?
                                        <h5>{documentName?.name2}</h5>
                                        :
                                        <>
                                            <h5>Click to Upload <span>or drag and drop</span></h5>
                                            <h6> (Max. File size: 100 MB)</h6>
                                        </>
                                }
                            </div>
                        </div>

                    </div>
                    <div className="col-xs-12">
                        <div className='Document buttons' style={{ margin: '30px 0', display: 'flex', justifyContent: 'center' }}>
                          <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>
                            <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save</button>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
